/**
 * Blue Theme Utilities
 * Centralized theme configuration for consistent styling across the platform
 */

/**
 * AMPA Sales Rep Portal - Style Guide Theme Utilities
 * Aligned with global design system
 */
export const BLUE_THEME = {
  colors: {
    primary: '#2563EB',        // 220 85% 52% - Primary brand blue
    primaryLight: '#60A5FA',   // Light blue
    primaryDark: '#1E40AF',    // Navy blue
    textPrimary: '#FFFFFF',    // White text
    textMuted: '#94A3B8',      // Gray text (215 20% 65%)
  },
  gradients: {
    card: 'linear-gradient(135deg, rgba(37, 99, 235, 0.08), rgba(30, 64, 175, 0.12))',
    cardVariant1: 'linear-gradient(135deg, rgba(96, 165, 250, 0.08), rgba(37, 99, 235, 0.12))',
    cardVariant2: 'linear-gradient(135deg, rgba(30, 64, 175, 0.08), rgba(37, 99, 235, 0.12))',
    cardHover: 'linear-gradient(135deg, rgba(96, 165, 250, 0.12), rgba(37, 99, 235, 0.16))',
    button: 'linear-gradient(to right, #2563EB, #60A5FA)',
    headerBg: 'linear-gradient(135deg, rgba(34, 39, 51, 0.98) 0%, rgba(45, 52, 66, 0.95) 50%, rgba(34, 39, 51, 0.98) 100%)',
  },
  borders: {
    primary: 'rgba(37, 99, 235, 0.4)',
    light: 'rgba(96, 165, 250, 0.4)',
    dark: 'rgba(30, 64, 175, 0.4)',
  },
  shadows: {
    card: '0 1px 3px rgba(0, 0, 0, 0.3)',
    cardHover: '0 8px 16px rgba(0, 0, 0, 0.12)',
    glow: '0 0 20px rgba(37, 99, 235, 0.3)',
  },
};

/**
 * Get standard card styling with blue theme
 */
export const getCardStyle = () => ({
  background: BLUE_THEME.gradients.card,
  borderColor: BLUE_THEME.borders.primary,
  borderWidth: '1px',
  borderStyle: 'solid' as const,
});

/**
 * Get card variant 1 styling (lighter blue)
 */
export const getCardVariant1Style = () => ({
  background: BLUE_THEME.gradients.cardVariant1,
  borderColor: BLUE_THEME.borders.light,
  borderWidth: '1px',
  borderStyle: 'solid' as const,
});

/**
 * Get card variant 2 styling (darker blue)
 */
export const getCardVariant2Style = () => ({
  background: BLUE_THEME.gradients.cardVariant2,
  borderColor: BLUE_THEME.borders.dark,
  borderWidth: '1px',
  borderStyle: 'solid' as const,
});

/**
 * Get card hover styling
 */
export const getCardHoverStyle = () => ({
  background: BLUE_THEME.gradients.cardHover,
  borderColor: BLUE_THEME.borders.light,
});

/**
 * Get minimal card styling (border only, no gradient background)
 * Clean aesthetic matching modern dashboard design
 */
export const getMinimalCardStyle = () => ({
  background: 'transparent',
  borderColor: "hsl(var(--primary) / 0.4)",
  borderWidth: '1px',
  borderStyle: 'solid' as const,
});
